var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSelected = function SvgSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.072 5.433l-8.992 8.88-2.45-2.801a1.5 1.5 0 00-2.258 1.976l3.5 4a1.5 1.5 0 002.183.08l10.125-10a1.501 1.501 0 00-2.108-2.135"
  })));
};
export default SvgSelected;